import React, { useContext } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { IApplicationState } from '../../store';
import { blobRequest } from '../../store/videos/slices';
import Loading from '../Loading';
import { Container, Content, Video } from './styles'
import ButtonDeletePhoto from '../ButtonDeletePhoto';
import Icon from '../../assets/Icon';
import { ThemeContext } from "styled-components";


interface Props {
    src: string;
    onOpen: () => void;
    onDelete: () => void;
}

// *** SHOW VIDEO 
const VideoThumb: React.FC<Props> = ({ src, onOpen = () => { }, onDelete = () => { } }) => {

    const blobState = useSelector((state: IApplicationState) => state.videos.blobs[src]);

    const dispatch = useDispatch();

    const theme = useContext(ThemeContext);

    return <Container >
        <ButtonDeletePhoto size={'medium'} prependIcon='trash' color='#ffffff' onClick={onDelete} />
        <Content onClick={() => {
            if (!blobState) {
                dispatch(blobRequest({
                    link: src
                }))
            }
            onOpen()
        }} >
            {!blobState && <Icon icon={'play'} size={50} color={theme.colors.background} />}
            {blobState && blobState.isLoading && <Loading />}
            {blobState && blobState.blob && <Video src={URL.createObjectURL(blobState.blob)} />}
        </Content>
    </Container>
}

export default VideoThumb;